(() => {
  'use strict';
  const guide = document.getElementById('feature-guide');
  if (!guide) return;
  const launcher = document.querySelector('[data-open="feature-guide"]');
  const sync = () => launcher?.setAttribute('aria-expanded', String(guide.open));
  new MutationObserver(sync).observe(guide, {attributes:true,attributeFilter:['open']});
  sync();
  guide.addEventListener('click', event => {
    if (event.target.closest('a[href^="#"]')) guide.close();
  });
})();
